export default __webpack_public_path__ + "static/media/error.32ddc9de.gif";